import { render, staticRenderFns } from "./searchHead.vue?vue&type=template&id=01067211&scoped=true"
import script from "./searchHead.vue?vue&type=script&lang=js"
export * from "./searchHead.vue?vue&type=script&lang=js"
import style0 from "./searchHead.vue?vue&type=style&index=0&id=01067211&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01067211",
  null
  
)

export default component.exports